/**
 * Kept out of promptBridgeBaseQuery.ts on purpose. That module imports RTK Query,
 * i18next and `platform/components`, so anything reaching for this one string had
 * to execute the design system with it — 20.4 s cold for
 * streamAssistantChat.spec.ts. See T20-133319.
 *
 * Deliberately NOT workspace-labelled: the gateway does not yet route /prompt-bridge/*
 * on workspace-labelled hosts; the backend resolves the workspace from the JWT.
 */
export const PROMPT_BRIDGE_BASE_URL = `${process.env.API_URL}/prompt-bridge`;
